import {
    EXPORT_CATEGORY_SALES_REPORT,
    EXPORT_CATEGORY_SALES_REPORT_FAIL,
    EXPORT_CATEGORY_SALES_REPORT_SUCCESS,
    EXPORT_CUSTOMER_REPORT,
    EXPORT_CUSTOMER_REPORT_FAIL,
    EXPORT_CUSTOMER_REPORT_SUCCESS,
    EXPORT_MARKETING_REPORT,
    EXPORT_MARKETING_REPORT_FAIL,
    EXPORT_MARKETING_REPORT_SUCCESS,
    EXPORT_PRODUCT_SALES_REPORT,
    EXPORT_PRODUCT_SALES_REPORT_FAIL,
    EXPORT_PRODUCT_SALES_REPORT_SUCCESS,
    EXPORT_SALES_REPORT,
    EXPORT_SALES_REPORT_FAIL,
    EXPORT_SALES_REPORT_SUCCESS,
    GET_CATEGORY_SALES_REPORT,
    GET_CATEGORY_SALES_REPORT_FAIL,
    GET_CATEGORY_SALES_REPORT_SUCCESS,
    GET_CUSTOMER_REPORT,
    GET_CUSTOMER_REPORT_FAIL,
    GET_CUSTOMER_REPORT_SUCCESS,
    GET_MARKETING_REPORT,
    GET_MARKETING_REPORT_FAIL,
    GET_MARKETING_REPORT_SUCCESS,
    GET_PRODUCT_SALES_REPORT,
    GET_PRODUCT_SALES_REPORT_FAIL,
    GET_PRODUCT_SALES_REPORT_SUCCESS,
    GET_SALES_REPORT,
    GET_SALES_REPORT_FAIL,
    GET_SALES_REPORT_SUCCESS,
    RESET_REPORT_ATTACHMENT_STATE,
    RESET_REPORT_STATE,
} from "./actionTypes";

export const getSalesReport = sales => ({
    type: GET_SALES_REPORT,
    payload: sales,
});

export const getSalesReportSuccess = sales => ({
    type: GET_SALES_REPORT_SUCCESS,
    payload: sales,
});

export const getSalesReportFail = error => ({
    type: GET_SALES_REPORT_FAIL,
    payload: error,
});

export const exportSalesReport = sales => ({
    type: EXPORT_SALES_REPORT,
    payload: sales,
});

export const exportSalesReportSuccess = sales => ({
    type: EXPORT_SALES_REPORT_SUCCESS,
    payload: sales,
});

export const exportSalesReportFail = error => ({
    type: EXPORT_SALES_REPORT_FAIL,
    payload: error,
});

export const getProductSalesReport = sales => ({
    type: GET_PRODUCT_SALES_REPORT,
    payload: sales,
});

export const getProductSalesReportSuccess = sales => ({
    type: GET_PRODUCT_SALES_REPORT_SUCCESS,
    payload: sales,
});

export const getProductSalesReportFail = error => ({
    type: GET_PRODUCT_SALES_REPORT_FAIL,
    payload: error,
});

export const exportProductSalesReport = sales => ({
    type: EXPORT_PRODUCT_SALES_REPORT,
    payload: sales,
});

export const exportProductSalesReportSuccess = sales => ({
    type: EXPORT_PRODUCT_SALES_REPORT_SUCCESS,
    payload: sales,
});

export const exportProductSalesReportFail = error => ({
    type: EXPORT_PRODUCT_SALES_REPORT_FAIL,
    payload: error,
});

export const getCategorySalesReport = sales => ({
    type: GET_CATEGORY_SALES_REPORT,
    payload: sales,
});

export const getCategorySalesReportSuccess = sales => ({
    type: GET_CATEGORY_SALES_REPORT_SUCCESS,
    payload: sales,
});

export const getCategorySalesReportFail = error => ({
    type: GET_CATEGORY_SALES_REPORT_FAIL,
    payload: error,
});

export const exportCategorySalesReport = sales => ({
    type: EXPORT_CATEGORY_SALES_REPORT,
    payload: sales,
});

export const exportCategorySalesReportSuccess = sales => ({
    type: EXPORT_CATEGORY_SALES_REPORT_SUCCESS,
    payload: sales,
});

export const exportCategorySalesReportFail = error => ({
    type: EXPORT_CATEGORY_SALES_REPORT_FAIL,
    payload: error,
});

export const getCustomerReport = sales => ({
    type: GET_CUSTOMER_REPORT,
    payload: sales,
});

export const getCustomerReportSuccess = sales => ({
    type: GET_CUSTOMER_REPORT_SUCCESS,
    payload: sales,
});

export const getCustomerReportFail = error => ({
    type: GET_CUSTOMER_REPORT_FAIL,
    payload: error,
});

export const exportCustomerReport = sales => ({
    type: EXPORT_CUSTOMER_REPORT,
    payload: sales,
});

export const exportCustomerReportSuccess = sales => ({
    type: EXPORT_CUSTOMER_REPORT_SUCCESS,
    payload: sales,
});

export const exportCustomerReportFail = error => ({
    type: EXPORT_CUSTOMER_REPORT_FAIL,
    payload: error,
});

export const getMarkettingReport = sales => ({
    type: GET_MARKETING_REPORT,
    payload: sales,
});

export const getMarkettingReportSuccess = sales => ({
    type: GET_MARKETING_REPORT_SUCCESS,
    payload: sales,
});

export const getMarkettingReportFail = error => ({
    type: GET_MARKETING_REPORT_FAIL,
    payload: error,
});

export const exportMarkettingReport = sales => ({
    type: EXPORT_MARKETING_REPORT,
    payload: sales,
});

export const exportMarkettingReportSuccess = sales => ({
    type: EXPORT_MARKETING_REPORT_SUCCESS,
    payload: sales,
});

export const exportMarkettingReportFail = error => ({
    type: EXPORT_MARKETING_REPORT_FAIL,
    payload: error,
});

//reset
export const resetReportState = () => {
    return {
        type: RESET_REPORT_STATE,
    }
}

export const resetReportAttachmentState = () => {
    return {
        type: RESET_REPORT_ATTACHMENT_STATE,
    }
}

